import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-desktop-apps-download',
  templateUrl: './desktop-apps-download.component.html',
  styleUrls: ['./desktop-apps-download.component.scss']
})
export class DesktopAppsDownloadComponent implements OnInit {

  linuxDownloadPath: string;
  windowsDownloadPath: string;
  macDownloadPath: string;

  constructor() { }

  ngOnInit(): void {
    this.linuxDownloadPath = '../../../../assets/desktopApp/linux/openworx.AppImage';
    this.windowsDownloadPath = '../../../../assets/desktopApp/windows/openworx.exe';
    this.macDownloadPath = '../../../../assets/desktopApp/mac/openworx.pkg'; 
  }
}
